import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TOAST_TYPE } from '@client/common/components/Toast';
import { showToast } from '@client/common/utils/showToast';
import { useTranslate } from '@client/i18n/hooks';
import { useProductReportErrorEffect } from '@client/product/hooks';
import { Form } from './Form';
import { FormValuesType, Props } from './FormContainer.types';

export const FormContainer = ({ onFormHide }: Props): ReactElement => {
  const t = useTranslate();
  const {
    data,
    reportProductError,
    clearReportProductError,
  } = useProductReportErrorEffect();
  const { sku } = useParams<{ sku: string }>();
  const { wasStarted, isLoading, isLoaded, hasFailed } = data;


  useEffect(() => () => {
    clearReportProductError();
  }, [clearReportProductError]);


  useEffect(() => {
    if (isLoaded && !hasFailed) {
      showToast(
        TOAST_TYPE.success,
        null,
        t('Error in product reported successfully'),
      );
      clearReportProductError();
      onFormHide();
    }
  }, [isLoaded, hasFailed, clearReportProductError, onFormHide, t]);

  const handleSubmit = (values: FormValuesType) => {
    reportProductError({
      details: {
        ...values,
        sku,
        path: window.location.href,
      },
    });
  };

  return (
    <Form
      onSubmit={handleSubmit}
      isSubmitting={wasStarted && isLoading}
      hasSubmissionFail={hasFailed}
      onFormHide={onFormHide}
    />
  );
};
